import { useEffect, useState, useRef } from 'react';
import {
    FormControlLabel, Checkbox, Typography, FormControl, MenuItem, InputLabel, Select, FormGroup
} from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import UnLock from '../../../../GlobalFunction/UnLock';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import { getRoomMasterdropdata, getShiftMasterdropdata, getYojnaMasterdropdata } from '../../../../Api/PropertyMst/Api';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useSelector } from 'react-redux';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 100 },
    { id: 'HkWrkStnName', label: 'Work Station', minWidth: 150 },
    { id: 'HkWrkAreaName', label: 'Work Area', minWidth: 150 },
    { id: 'Abrv', label: 'Abbreviation', minWidth: 100 },
];

const YojnaAlocation = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [searchTask, setSearchTask] = useState('');
    const [isPreviousDisabled, setIsPreviousDisabled] = useState(false);
    const [shiftData, setShiftData] = useState([]);
    const [isNextDisabled, setIsNextDisabled] = useState(false);
    const [dropdownData, setDropdownData] = useState([]);
    const [yojna, setYojna] = useState([]);
    const [formData, setFormData] = useState({
        YojanaName: '',
        Abrv: '',
        Remark: '',
        Property: '',
        Shift: '',
        Yojna: '',
        WorkStation: '',
    });

    const [error, setError] = useState({
        YojanaName: false,
        Abrv: false,
    });

    const navigate = useNavigate();
    const location = useLocation();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [currentYojana, setCurrentYojana] = useState(null);
    const [mode, setMode] = useState('view');
    const [status, setStatus] = useState("1");
    const [lastInsertedYojanaId, setLastInsertedYojanaId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [userId] = useState(sessionStorage.getItem('UserId'));
    const [dataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const [selectedYojanas, setSelectedYojanas] = useState([]);
    const [selectedWorkAreas, setSelectedWorkAreas] = useState([]);
    const [originalRows, setOriginalRows] = useState([]);
    const [isRetrieveLoading, setIsRetrieveLoading] = useState(false);
    const [workStn, setWorkStn] = useState([]);
    const [yojanaTaskList, setYojanaTaskList] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const yojanaNameRef = useRef(null);
    const globalProperty = useSelector(selectGlobalProperty);
    const [showAllSubstations, setShowAllSubstations] = useState(false);
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    useEffect(() => {
        if (location.state?.YojanaId && location.state?.PropId && location.state?.ShiftId) {
            const propId = location.state.PropId.toString();
            const shiftId = location.state.ShiftId.toString();
            const yojanaId = location.state.YojanaId.toString();

            setFormData(prev => ({
                ...prev,
                Property: propId,
                Shift: shiftId,
                Yojna: yojanaId,
            }));

            setCurrentYojana(location.state.YojanaId);
            setMode('view');
            setIsFormDisabled(true);
            handleRetrieveWithExactIds(propId, shiftId, yojanaId);
        } else if (!location.state) {
            setMode('add');
            setIsFormDisabled(false);
            setSelectedWorkAreas([]);
            setRows([]);
        }
    }, [location.state]);

    // Re-apply correct Shift value after shiftData is loaded
    useEffect(() => {
        if (shiftData.length > 0 && location.state?.ShiftId) {
            const correctShift = shiftData.find(item => item.id === location.state.ShiftId);
            if (correctShift) {
                setFormData(prev => ({ ...prev, Shift: correctShift.id.toString() }));
            }
        }
    }, [shiftData, location.state?.ShiftId]);

    // Re-apply correct Yojna value after yojna data is loaded
    useEffect(() => {
        if (yojna.length > 0 && location.state?.YojanaId) {
            const correctYojna = yojna.find(item => item.id === location.state.YojanaId);
            if (correctYojna) {
                setFormData(prev => ({ ...prev, Yojna: correctYojna.id.toString() }));
            }
        }
    }, [yojna, location.state?.YojanaId]);

    // Re-apply correct Property after dropdownData loads
    useEffect(() => {
        if (dropdownData.length > 0 && location.state?.PropId) {
            const correctProp = dropdownData.find(item => item.id === location.state.PropId);
            if (correctProp) {
                setFormData(prev => ({ ...prev, Property: correctProp.id.toString() }));
            }
        }
    }, [dropdownData, location.state?.PropId]);

    const handleRetrieveWithExactIds = async (propId, shiftId, yojanaId) => {
        setIsRetrieveLoading(true);
        setRows([]);
        setSelectedWorkAreas([]);

        try {
            const payload = {
                PropId: parseInt(propId),
                YojanaId: parseInt(yojanaId),
                ShiftId: parseInt(shiftId),
                HkWrkAreaId: 1
            };

            const response = await axiosInstance.post(
                'MstYojana/RetriveMstYojanaWiseArea',
                payload
            );

            if (response.data?.Status === 0 && response.data?.Data?.length > 0) {
                const formattedData = response.data.Data.map((item, index) => ({
                    RowNum: index + 1,
                    HkWrkAreaId: item.HkWrkAreaId,
                    HkWrkStnName: item.HkWrkStnName || 'N/A',
                    HkWrkAreaName: item.HkWrkAreaName || 'N/A',
                    Abrv: item.Abrv || 'N/A',
                    IsAllocated: item.Id > 0,
                }));

                setRows(formattedData);

                const checkedIds = formattedData
                    .filter(row => row.IsAllocated)
                    .map(row => row.HkWrkAreaId);

                setSelectedWorkAreas(checkedIds);
            } else {
                setRows([]);
                setSelectedWorkAreas([]);
                toast.info("No substations allocated for this combination");
            }
        } catch (error) {
            toast.error("Error loading data");
            setRows([]);
            setSelectedWorkAreas([]);
        } finally {
            setIsRetrieveLoading(false);
        }
    };

    const deleteYojanaData = async (id) => {
        try {
            const response = await axiosInstance.post(`MstYojana/DeleteMstYojana`, {
                YojanaId: parseInt(id),
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message || 'Data deleted successfully.');
                return true;
            } else {
                toast.info(response.data.Message || 'Failed to delete record.');
                return false;
            }
        } catch (error) {
            toast.error('Error while deleting yojana.');
            return false;
        }
    };

    const handlePrevious = async () => {
        if (currentYojana && currentYojana > 1 && !isPreviousDisabled) {
            await handleRetrieve(currentYojana, "P");
        }
    };

    const handleNext = async () => {
        if (currentYojana) {
            await handleRetrieve(currentYojana, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleCheckboxChange = (HkWrkAreaId, isChecked) => {
        if (isChecked) {
            setSelectedWorkAreas(prev => [...prev, HkWrkAreaId]);
        } else {
            setSelectedWorkAreas(prev => prev.filter(id => id !== HkWrkAreaId));
        }
    };

    const handleRetrieve = async () => {
        if (!formData.Property) {
            toast.error('Property is required');
            return;
        }
        if (!formData.Shift) {
            toast.error('Shift is required');
            return;
        }
        if (!formData.Yojna) {
            toast.error('Yojna is required');
            return;
        }

        setIsRetrieveLoading(true);
        setRows([]);
        setSelectedWorkAreas([]);

        try {
            const payload = {
                PropId: parseInt(formData.Property),
                YojanaId: parseInt(formData.Yojna),
                ShiftId: parseInt(formData.Shift),
                HkWrkAreaId: 1
            };

            const response = await axiosInstance.post(
                'MstYojana/RetriveMstYojanaWiseArea',
                payload
            );

            if (response.data?.Status === 0 && response.data?.Data?.length > 0) {
                const formattedData = response.data.Data.map((item, index) => ({
                    RowNum: index + 1,
                    HkWrkAreaId: item.HkWrkAreaId,
                    HkWrkStnName: item.HkWrkStnName || 'N/A',
                    HkWrkAreaName: item.HkWrkAreaName || 'N/A',
                    Abrv: item.Abrv || 'N/A',
                    IsAllocated: item.Id > 0,
                }));

                setRows(formattedData);

                const checkedIds = formattedData
                    .filter(row => row.IsAllocated)
                    .map(row => row.HkWrkAreaId);

                setSelectedWorkAreas(checkedIds);
            } else {
                setRows([]);
                setSelectedWorkAreas([]);
                toast.info(response.data?.Message || "No substations found for this combination");
            }
        } catch (error) {
            toast.error("Error loading allocated substations");
            setRows([]);
            setSelectedWorkAreas([]);
        } finally {
            setIsRetrieveLoading(false);
        }
    };

    const handleSubmit = async () => {
        let hasError = false;

        if (!formData.Property) {
            toast.error('Property is required');
            hasError = true;
        }
        if (!formData.Shift) {
            toast.error('Shift is required');
            hasError = true;
        }
        if (!formData.Yojna) {
            toast.error('Yojna is required');
            hasError = true;
        }
        if (selectedWorkAreas.length === 0) {
            toast.error('Please select at least one Work Area');
            hasError = true;
        }

        if (hasError) return;

        try {

            const payload = [];

            selectedWorkAreas.forEach(HkWrkAreaId => {
                payload.push({
                    PropId: parseInt(formData.Property),
                    YojanaId: parseInt(formData.Yojna),
                    ShiftId: parseInt(formData.Shift),
                    HkWrkAreaId: HkWrkAreaId
                });
            });

            const response = await axiosInstance.post(`MstYojana/MangeMstYojanaWiseHkWrkArea`, payload);

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message || 'Yojana Allocation saved successfully.');
                setMode('view');
                setIsFormDisabled(true);
                await handleRetrieve();
            } else {
                toast.info(response.data.Message || 'Operation failed.');
            }
        } catch (error) {
            toast.error('Error while saving Yojana Allocation.');
        }
    };

    const handleEdit = async () => {
        let flag = await checkAndLock(currentYojana, "MstYojana", "YojanaId");
        switch (flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record Already Locked.", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock.", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong.", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setCurrentYojana(null);
        setStatus("1");
        setSelectedWorkAreas([]);
        setSelectedYojanas([]);

        const resetRows = originalRows.map(row => ({
            ...row,
            IsAllocated: false
        }));
        setRows(resetRows);

        setTimeout(() => {
            yojanaNameRef.current?.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            if (mode === 'edit' && currentYojana) {
                await handleRetrieve(currentYojana, "R");
                await UnLock(currentYojana, "MstYojana", "YojanaId");
            } else if (mode === 'add') {
                if (lastInsertedYojanaId) {
                    await handleRetrieve(lastInsertedYojanaId, "R");
                    setCurrentYojana(lastInsertedYojanaId);
                } else {
                    setIsFormDisabled(true);
                    setSelectedWorkAreas([]);
                    setSelectedYojanas([]);
                    const resetRows = originalRows.map(row => ({
                        ...row,
                        IsAllocated: false
                    }));
                    setRows(resetRows);
                }
            }
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    useEffect(() => {
        if (globalProperty && globalProperty !== formData.Property) {
            setFormData(prevState => ({
                ...prevState,
                Property: globalProperty.toString()
            }));
        }
    }, [globalProperty]);

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const response = await getRoomMasterdropdata({
                    Flag: "",
                    UserId: userId,
                });
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data?.map((item) => ({
                        id: item.PropId,
                        name: item.Name,
                    }));
                    setDropdownData(dropdownItems);
                    if (globalProperty) {
                        const globalPropExists = dropdownItems.find(item =>
                            item.id.toString() === globalProperty.toString()
                        );

                        if (globalPropExists) {
                            setFormData(prev => ({
                                ...prev,
                                Property: globalProperty.toString()
                            }));
                        } else if (dropdownItems.length > 0) {
                            setFormData(prev => ({
                                ...prev,
                                Property: dropdownItems[0].id.toString()
                            }));
                        }
                    } else if (dropdownItems.length > 0) {
                        setFormData(prev => ({
                            ...prev,
                            Property: dropdownItems[0].id.toString()
                        }));
                    }
                }
            } catch (error) {
                toast.error("Error fetching property data");
            }
        };
        fetchDropdownData();
    }, [userId]);

    useEffect(() => {
        const fetchShiftData = async () => {
            try {
                const response = await getShiftMasterdropdata();
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.ShiftId,
                        name: item.ShiftName,
                    }));
                    setShiftData(dropdownItems);
                    if (dropdownItems.length > 0) {
                        setFormData(prev => ({ ...prev, Shift: dropdownItems[0].id }));
                    }
                }
            } catch (error) {
                toast.error("Error fetching shift data");
            }
        };
        fetchShiftData();
    }, []);

    useEffect(() => {
        const fetchYojnaData = async () => {
            try {
                const response = await getYojnaMasterdropdata({
                    Flag: "",
                    YojanaId: 1
                });
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.YojanaId,
                        name: item.YojanaName,
                    }));
                    setYojna(dropdownItems);
                    if (dropdownItems.length > 0) {
                        setFormData(prev => ({ ...prev, Yojna: dropdownItems[0].id }));
                    }
                }
            } catch (error) {
                toast.error("Error fetching shift data");
            }
        };
        fetchYojnaData();
    }, []);

    useEffect(() => {
        const fetchYojnaTaskList = async () => {
            try {
                const response = await axiosInstance.post("MstYojana/GetdrpMstYojana", {
                    Flag: "Task",
                    YojanaId: parseInt(formData.Yojna)
                })
                if (response?.data?.Status === 0 && response.data.Data) {
                    const taskList = response.data.Data.map((item) => ({
                        id: item.HkTaskId,
                        name: item.HkTaskName,
                        YojanaDtlId: item.YojanaDtlId
                    }));
                    setYojanaTaskList(taskList);
                } else {
                    setYojanaTaskList([]);
                }
            } catch (error) {
                toast.error("Error while fetching yojana list.");
            }
        };
        fetchYojnaTaskList();
    }, [formData.Yojna])

    useEffect(() => {
        const fetchWorkStation = async () => {
            try {
                const response = await axiosInstance.post("MstHkWrkStn/getMstHkWrkStndrp", {
                    PropId: parseInt(formData.Property)
                });
                if (response?.data?.Status === 0) {
                    const dropDown = [{ id: 1, name: "All" },
                    ...response.data.Data.map((item) => ({
                        id: item.Id,
                        name: item.Name,
                    }))];
                    setWorkStn(dropDown);
                    if (!formData.WorkStation) {
                        setFormData(prevState => ({ ...prevState, WorkStation: 1 }));
                    }
                }
            } catch (error) {
                toast.error("Error while fetching the work station.");
            }
        };
        fetchWorkStation();
    }, []);

    const handleExit = () => {
        navigate('/yojana-alocationtable');
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        const flag = await checkAndLock(currentYojana, "MstYojana", "YojanaId");
        switch (flag) {
            case 0:
                setOpenConfirmDialog(false);
                await deleteYojanaData(currentYojana);
                setStatus("1");
                setMode('view');
                setIsFormDisabled(true);
                setSelectedWorkAreas([]);
                setSelectedYojanas([]);
                break;
            case 1:
                toast.info("Record Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong", { autoClose: 500 });
        }
    };

    const displayedRows = showAllSubstations ? rows : rows.filter(row => row.IsAllocated);

    const filteredRows = displayedRows.filter(row =>
        searchQuery === '' ||
        (row.HkWrkAreaName && row.HkWrkAreaName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (row.HkWrkStnName && row.HkWrkStnName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (row.Abrv && row.Abrv.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    const filteredTask = rows.filter(row => searchTask === '' || (row.HkTaskName && row.HkTaskName.toLowerCase().includes(searchTask.toLowerCase())));

    useEffect(() => {
        if (filteredRows.length === 0) {
            setSelectAllChecked(false);
            return;
        }

        const allVisibleSelected = filteredRows.every(row =>
            selectedWorkAreas.includes(row.HkWrkAreaId)
        );

        setSelectAllChecked(allVisibleSelected);
    }, [selectedWorkAreas, filteredRows, showAllSubstations, searchQuery]);

    return (
        <>
            <Box className="form-container" sx={{
                width: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                maxWidth: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                height: { xs: "91.5vh", sm: "93.5vh", md: "auto", lg: "92vh" },
                overflowX: "hidden",
                overflowY: { xs: "auto", sm: "hidden", md: "hidden", lg: "hidden" },
            }}>
                <ToastContainer />
                <Grid container spacing={1} className="form_grid" sx={{ width: '90% !important' }}>
                    <Grid item xs={12} className="form_title"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            // justifyContent: 'space-between',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '7px', sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '7px' }, display: 'block' }}
                                disabled={mode !== 'view' || !currentYojana || currentYojana === 1 || isPreviousDisabled}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: 'block' }}
                                disabled={mode !== 'view' || !currentYojana || isNextDisabled}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' },
                            }}
                        >
                            Yojana Allocation/Substation
                        </Typography>

                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CrudButtons
                                moduleName="Yojana Allocate to SubStation"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field" mt={2}>
                        <Box sx={{ width: '100%' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={3}>
                                    <FormControl variant="filled" fullWidth className="custom-textfield">
                                        <InputLabel id="property-label">Property</InputLabel>
                                        <Select
                                            labelId="property-label"
                                            id="Property"
                                            name="Property"
                                            value={formData.Property}
                                            onChange={handleInputChange}
                                            disabled={isFormDisabled}
                                        >
                                            {dropdownData.map((item) => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl variant="filled" fullWidth className="custom-textfield">
                                        <InputLabel id="shift-label">Shift</InputLabel>
                                        <Select
                                            labelId="shift-label"
                                            id="Shift"
                                            name="Shift"
                                            value={formData.Shift}
                                            onChange={handleInputChange}
                                            disabled={isFormDisabled}
                                        >
                                            {shiftData.map((item) => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl variant="filled" fullWidth className="custom-textfield">
                                        <InputLabel id="yojna-label">Yojna Name</InputLabel>
                                        <Select
                                            labelId="yojna-label"
                                            id="Yojna"
                                            name="Yojna"
                                            value={formData.Yojna}
                                            onChange={handleInputChange}
                                            disabled={isFormDisabled}
                                        >
                                            {yojna.map((item) => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={1.5}>
                                    <Button
                                        size='small'
                                        variant="contained"
                                        onClick={() => setShowAllSubstations(prev => !prev)}
                                        sx={{
                                            bgcolor: '#635bff',
                                            '&:hover': {
                                                bgcolor: '#635bff',
                                            },
                                        }}
                                    >
                                        {showAllSubstations ? 'Allocated' : 'Show All'}
                                    </Button>
                                </Grid>
                                <Grid item xs={12} md={1.5}>
                                    <Button
                                        size='small'
                                        variant="contained"
                                        onClick={handleRetrieve}
                                        disabled={isRetrieveLoading || isFormDisabled}
                                        sx={{
                                            bgcolor: '#635bff',
                                            '&:hover': {
                                                bgcolor: '#635bff',
                                            },
                                        }}
                                    >
                                        {isRetrieveLoading ? 'Retrieving...' : 'Retrieve'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid >

                    <Grid item xs={12} mt={2} className="form_field">
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={3}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: 420,
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '6px',
                                        overflow: 'hidden',
                                        bgcolor: '#fafafa',
                                    }}
                                >
                                    {/* Header */}
                                    <Box
                                        sx={{
                                            p: 1.5,
                                            borderBottom: '1px solid #e0e0e0',
                                            bgcolor: '#f0f4ff',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            flexWrap: 'wrap',
                                            gap: 1,
                                        }}
                                    >
                                        <Typography variant="subtitle2" fontWeight="bold">
                                            Task List
                                        </Typography>

                                        <TextField
                                            placeholder="Search task..."
                                            size="small"
                                            value={searchTask}
                                            onChange={(e) => setSearchTask(e.target.value)}
                                            disabled={isFormDisabled}
                                            sx={{
                                                width: { xs: 140, md: 180 },
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '20px',
                                                    height: 32,
                                                    fontSize: '0.875rem',
                                                },
                                            }}
                                            InputProps={{
                                                endAdornment: searchTask && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => setSearchTask('')}
                                                        edge="end"
                                                    >
                                                        <ClearIcon fontSize="small" />
                                                    </IconButton>
                                                ),
                                            }}
                                        />
                                    </Box>

                                    {/* Scrollable content */}
                                    <Box sx={{ flex: 1, overflowY: 'auto', position: 'relative' }}>
                                        <Box
                                            sx={{
                                                p: 1.5,
                                                display: 'grid',
                                                gridTemplateColumns: {
                                                    xs: '1fr',
                                                    sm: '1fr 1fr',
                                                    md: '1fr',
                                                    lg: '1fr',
                                                },
                                                gap: 0.5,
                                            }}
                                        >
                                            {yojanaTaskList.length > 0 ? (
                                                yojanaTaskList
                                                    .filter((task) =>
                                                        !searchTask.trim() ||
                                                        task.name.toLowerCase().includes(searchTask.toLowerCase())
                                                    )
                                                    .map((task) => (
                                                        <Box
                                                            key={task.id}
                                                            sx={{
                                                                // py: 0.75,
                                                                px: 1,
                                                                borderBottom: '1px solid #eee',
                                                                '&:last-child': { borderBottom: 'none' },
                                                            }}
                                                        >
                                                            <Typography variant="body2">{task.name}</Typography>
                                                        </Box>
                                                    ))
                                            ) : (
                                                <Box
                                                    sx={{
                                                        gridColumn: '1 / -1',
                                                        minHeight: '160px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        color: 'text.secondary',
                                                        textAlign: 'center',
                                                        p: 3,
                                                    }}
                                                >
                                                    {formData.Yojna
                                                        ? 'No tasks found for this Yojana'
                                                        : 'Select a Yojana to view tasks'}
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>

                                    {/* Footer count */}
                                    {yojanaTaskList.length > 0 && (
                                        <Box
                                            sx={{
                                                px: 1.5,
                                                py: 0.75,
                                                borderTop: '1px solid #e0e0e0',
                                                fontSize: '0.8rem',
                                                color: 'text.secondary',
                                                bgcolor: '#f8f9fa',
                                            }}
                                        >
                                            Showing{' '}
                                            {
                                                yojanaTaskList.filter((task) =>
                                                    !searchTask.trim() ||
                                                    task.name.toLowerCase().includes(searchTask.toLowerCase())
                                                ).length
                                            } task
                                            {yojanaTaskList.length !== 1 ? 's' : ''}
                                        </Box>
                                    )}
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={9}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: 420,
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '6px',
                                        overflow: 'hidden',
                                        bgcolor: '#fafafa',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            p: 1.5,
                                            borderBottom: '1px solid #e0e0e0',
                                            bgcolor: '#f0f4ff',
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 1.5,
                                            alignItems: 'center',
                                            justifyContent: { xs: 'flex-start', sm: 'space-between' },
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                                            <Typography variant="subtitle2" fontWeight="bold">
                                                Substation List
                                            </Typography>

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={selectAllChecked}
                                                        indeterminate={
                                                            !selectAllChecked &&
                                                            filteredRows.length > 0 &&
                                                            filteredRows.some((r) => selectedWorkAreas.includes(r.HkWrkAreaId)) &&
                                                            !filteredRows.every((r) => selectedWorkAreas.includes(r.HkWrkAreaId))
                                                        }
                                                        onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            setSelectAllChecked(checked);
                                                            if (checked) {
                                                                const toAdd = filteredRows
                                                                    .filter((r) => !selectedWorkAreas.includes(r.HkWrkAreaId))
                                                                    .map((r) => r.HkWrkAreaId);
                                                                setSelectedWorkAreas((prev) => [...new Set([...prev, ...toAdd])]);
                                                            } else {
                                                                const visible = new Set(filteredRows.map((r) => r.HkWrkAreaId));
                                                                setSelectedWorkAreas((prev) => prev.filter((id) => !visible.has(id)));
                                                            }
                                                        }}
                                                        color="success"
                                                    />
                                                }
                                                label="Select All"
                                                sx={{ m: 0 }}
                                            />
                                        </Box>

                                        <TextField
                                            placeholder="Search area or station..."
                                            size="small"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            disabled={isFormDisabled}
                                            sx={{
                                                width: { xs: 200, sm: 260, md: 300 },
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '20px',
                                                    height: 32,
                                                    fontSize: '0.875rem',
                                                },
                                            }}
                                            InputProps={{
                                                endAdornment: searchQuery && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => setSearchQuery('')}
                                                        edge="end"
                                                    >
                                                        <ClearIcon fontSize="small" />
                                                    </IconButton>
                                                ),
                                            }}
                                        />
                                    </Box>

                                    {/* Scrollable content */}
                                    <Box sx={{ flex: 1, overflowY: 'auto', position: 'relative' }}>
                                        <Box
                                            sx={{
                                                p: 1.5,
                                                display: 'grid',
                                                gridTemplateColumns: {
                                                    xs: '1fr',
                                                    sm: '1fr 1fr',
                                                    md: '1fr 1fr 1fr',
                                                    lg: '1fr 1fr 1fr 1fr',
                                                },
                                                gap: 0.5,
                                            }}
                                        >
                                            {filteredRows.length > 0 ? (
                                                filteredRows.map((row) => (
                                                    <FormControlLabel
                                                        key={row.HkWrkAreaId}
                                                        control={
                                                            <Checkbox
                                                                size="small"
                                                                checked={selectedWorkAreas.includes(row.HkWrkAreaId)}
                                                                onChange={(e) =>
                                                                    handleCheckboxChange(row.HkWrkAreaId, e.target.checked)
                                                                }
                                                                disabled={isFormDisabled}
                                                                color="success"
                                                                sx={{ transform: 'scale(0.8)', p: 0.5 }}
                                                            />
                                                        }
                                                        label={
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    color: row.IsAllocated ? 'success.main' : 'text.primary',
                                                                    fontWeight: row.IsAllocated ? 600 : 400,
                                                                }}
                                                            >
                                                                {row.HkWrkStnName?.trim()
                                                                    ? `${row.HkWrkStnName} / ${row.HkWrkAreaName}`
                                                                    : row.HkWrkAreaName}
                                                                {row.IsAllocated && ' ✓'}
                                                            </Typography>
                                                        }
                                                        sx={{
                                                            m: 0,
                                                            alignItems: 'flex-start',
                                                            '& .MuiFormControlLabel-label': { fontSize: '0.875rem' },
                                                        }}
                                                    />
                                                ))
                                            ) : (
                                                <Box
                                                    sx={{
                                                        gridColumn: '1 / -1',
                                                        minHeight: '180px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        color: 'text.secondary',
                                                        textAlign: 'center',
                                                        p: 4,
                                                    }}
                                                >
                                                    {isRetrieveLoading
                                                        ? 'Loading allocated substations...'
                                                        : 'No substations found for selected Property + Shift + Yojna'}
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>

                                    <Box
                                        sx={{
                                            px: 1.5,
                                            py: 0.75,
                                            borderTop: '1px solid #e0e0e0',
                                            fontSize: '0.8rem',
                                            color: 'text.secondary',
                                            bgcolor: '#f8f9fa',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            flexWrap: 'wrap',
                                            gap: 1,
                                        }}
                                    >
                                        {selectedWorkAreas.length > 0 && (
                                            <span>Selected: {selectedWorkAreas.length}</span>
                                        )}
                                        <span sx={{ ml: 'auto' }}>
                                            Showing {filteredRows.length} of {rows.length}
                                            {!showAllSubstations && rows.some((r) => r.IsAllocated) && ' (allocated only)'}
                                        </span>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }}
                                    onClick={handleAdd}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }}
                                    onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                    }}
                                    onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                    }}
                                    onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid >
            </Box >

            <div style={{ display: 'none' }}>
                {Object.keys(dataForPrint).length > 0 && (
                    <ReportTable
                        columns={columns}
                        rows={rows}
                        title="Yojana Allocation"
                        contentRef={contentRef}
                        customStyles={{ backgroundColor: '#f5f5f5' }}
                    />
                )}
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this Yojana record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default YojnaAlocation;